package kz.dentalcrm.app.screens.employees.mvi

import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.core.base.Selectable
import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.data.network.response_model.employees.Employee
import kz.dentalcrm.app.data.network.response_model.employees.Position

data class EmployeesState(
    val employees: PersistentList<Employee> = persistentListOf(),
    val screenState: ScreenState = ScreenState.Idle,
    val positions: PersistentList<Selectable<Position>> = persistentListOf()
) : ViewState {
    sealed interface ScreenState {
        data object Idle : ScreenState
        data object Loading : ScreenState
        data class Error(val text: String) : ScreenState
    }
}
